import { axiosV2 } from 'interceptors/axios';
import { Dispatch } from 'redux';
import { dispatchError } from 'utils/dispatchError';

import { decryptResponse } from 'utils/token';

type AddDocumentToPartnerProps = {
  partnerId: string;
  documentId: string;
};

export const addDocumentToPartner =
  ({ partnerId, documentId }: AddDocumentToPartnerProps) =>
  async (dispatch: Dispatch) => {
    const body = { partnerId, documentId };
    try {
      const { data } = await axiosV2.put(`/partners/document`, body);

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      return dispatchError(error, dispatch);
    }
  };
